
const ExpertDomainItems = [
  "1．消化器・消化管",
  "2．消化器・肝胆膵",
  "3．循環器・心血管",
  "4．呼吸器・肺・縦隔",
  "5．血液",
  "6．脳・神経",
  "7．尿路系・腎臓",
  "8．内分泌代謝・糖尿病",
  "9．リウマチ・アレルギー",
  "10．感染症",
  "11．心療内科",
  "12．老年病",
  "13．小児外科",
  "14．スポーツ医学",
  "15．上肢の外科",
  "16．下肢の外科",
  "17．脊椎の外科",
  "18．産業医学",
  "19．画像診断",
  "20．歯科・口腔外科",
  "21．障がい者医療",
  "99．その他"
  ];

export default ExpertDomainItems;
